import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import { CommonKeys } from '@components/EntityDrawers/constants/keys';
import { ISelectOption } from '@constants/entities/ui';
import useProjectData from '@hooks/useProjectData';
import { transformArrayToOptions } from '@utils/helpers';

const useOwnerOptions = (formKey: string) => {
  const [{ settingsData }] = useProjectData();

  const selectedOwners = useWatch({
    name: formKey,
  }) as ISelectOption[];

  const ownersToDelete = useWatch({
    name: CommonKeys.OwnersToDelete,
  }) as string[] | undefined;

  const ownersOptions = useMemo(() => {
    const deleteSet = new Set(ownersToDelete ?? []);

    const uniqueSelectedOwners = new Set([
      ...selectedOwners.map(({ value }) => value),
      ...(settingsData?.requirement_owners ?? []),
    ]);

    const ownersArray = Array.from(uniqueSelectedOwners).filter(
      (owner) => !deleteSet.has(owner.toString()),
    );

    ownersArray.sort((a, b) =>
      a.toString().toLowerCase().localeCompare(b.toString().toLowerCase()),
    );

    return transformArrayToOptions(ownersArray);
  }, [settingsData, selectedOwners, ownersToDelete]);

  return { ownersOptions };
};

export default useOwnerOptions;
